var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullscreenEnter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 25 25",
    height: 25,
    viewBox: "0 0 25 25",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.249 2.751h-8.478l3.364 3.364-4.384 4.385 1.751 1.749 4.384-4.384 3.363 3.364z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2.751 22.249h8.478l-3.364-3.363 4.384-4.385-1.751-1.749-4.383 4.383-3.364-3.364z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenEnter);
export default __webpack_public_path__ + "static/media/fullscreen_enter.f64187690775757a2ac13fdcf9c94d96.svg";
export { ForwardRef as ReactComponent };